import React from "react";
import { ErrorMessage } from "@hookform/error-message";
import { Row, Col } from "react-bootstrap";
import { Controller } from "react-hook-form";
import DefaultSelect from "../../../../general/DefaultSelect";
import Req from "../../../../general/Req";
import { useUser } from "../../../../../util/user";
import { sendDuplicatedEmailNotification } from "../../../../../util/email";

const UserFormElementsKC = (props) => {
	const item = props.item;
	const index = props.index;
	const errors = props.errors;
	const register = props.register;
	const control = props.control;
	const setValue = props.setValue;
	const remove = props.remove;
	const existingUsers = props.existingUsers;
	const deptSelectOptions = props.deptSelectOptions;
	const countriesOptions = props.countriesOptions;

	const itemName = `usersObj[${index}]`;

	const currentUser = useUser();

	const checkboxStyle = {
		borderBottomStyle: "none",
	};

	const selectRowStyle = { marginTop: "15px", marginBottom: "15px" };

	const removeBtnStyle = {
		textAlign: "right",
		paddingRight: "20px",
		color: "red",
	};

	/**
	 * Handle checkbox inputs and site select per user object
	 * @param {obj} e
	 * @param {string} inputName
	 */
	const handleCheck = (e, inputName) => {
		const isChecked = e.target.checked;

		setValue(inputName, isChecked);
	};

	/**
	 * Set dept id per user object
	 * @param {obj} e
	 * @param {string} inputName
	 */
	const handleOnChange = (e, inputName) => setValue(inputName, e.value);

	/**
	 * Render dept select
	 * @param {obj} field
	 * @param {string} inputName
	 * @returns Dept select component
	 */
	const renderSelect = (field, inputName, selectOpts) => {
		const selectedOpt = selectOpts.find(option => option.value === field.value);
		return (
			<DefaultSelect
				value={selectedOpt}
				options={selectOpts}
				onChange={(e) => handleOnChange(e, inputName)}
			/>
		);
	};

	return (
		<div key={item.user_id} className="user-obj">
			<div className="user-header">
				<Row>
					<Col md="11">
						<h5>User {index + 1}</h5>
						<input
							name={`${itemName}.user_id`}
							ref={register()}
							defaultValue={item.user_id}
							style={{
								visibility: "hidden",
								height: "0",
								padding: "0",
								margin: "0",
							}}
						/>
					</Col>
					<Col md="1" style={removeBtnStyle}>
						<span
							onClick={() => {
								remove(index);
							}}
						>
							<span className="glyphicon glyphicon-remove"></span>
						</span>
					</Col>
				</Row>
			</div>
			<div className="user-body">
				<Row>
					<Col md="2">
						<h6 htmlFor="first_name">
							First Name <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.first_name`}
							ref={register({ required: "*required" })}
							defaultValue={item.first_name}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.first_name`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
					<Col md="2">
						<h6 htmlFor="last_name">
							Last Name <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.last_name`}
							ref={register({ required: "*required" })}
							defaultValue={item.last_name}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.last_name`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row>
					<Col md="2">
						<h6 htmlFor="nick_name">Nickname</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.nick_name`}
							ref={register()}
							defaultValue={item.nick_name}
						/>
					</Col>
					<Col md="2">
						<h6 htmlFor="email">
							Email Address <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.email`}
							ref={register({
								required: "*required",
								validate: value => {
									if(existingUsers.filter(user => parseInt(item.user_id) !== parseInt(user.user_id)).map(user => user.email).includes(value.trim())) {
										const duplicatedEmail = value.trim();
										const userUsingForm = { name: currentUser.name, email: currentUser.email };
										sendDuplicatedEmailNotification(duplicatedEmail, userUsingForm);
										return "Email already existed";
									}
									return true;
								},
							})}
							defaultValue={item.email}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.email`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row style={selectRowStyle}>
					<Col md="2">
						<h6 htmlFor="dept_id">
							Department <Req />
						</h6>
					</Col>
					<Col md="4">
						<Controller
							name={`${itemName}.dept_id`}
							control={control}
							defaultValue={item.dept_id}
							rules={{ required: "*required" }}
							render={(field, fieldState) =>
								renderSelect(field, `${itemName}.dept_id`, deptSelectOptions)
							}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.dept_id`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
					<Col md="2">
						<h6 htmlFor="position">
							Position <Req />
						</h6>
					</Col>
					<Col md="4">
						<input
							name={`${itemName}.position`}
							ref={register({ required: "*required" })}
							defaultValue={item.position}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.position`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row style={selectRowStyle}>
					<Col md="2">
						<h6 htmlFor="country">
							Country <Req />
						</h6>
					</Col>
					<Col md="6">
						<Controller
							name={`${itemName}.country`}
							control={control}
							defaultValue={item.country}
							rules={{ required: "*required" }}
							render={(field, fieldState) =>
								renderSelect(field, `${itemName}.country`, countriesOptions)
							}
						/>
						<ErrorMessage
							errors={errors}
							name={`${itemName}.country`}
							render={({ message }) => <Req message={message} />}
						/>
					</Col>
				</Row>
				<Row>
					<Col md="3"></Col>

					<Col md="3"></Col>
					<Col md="2">
						<label>See Invoices</label>
					</Col>
					<Col md="1">
						<Controller
							name={`${itemName}.seesInvoices`}
							control={control}
							defaultValue={item.seesInvoices}
							render={(field, fieldState) => (
								<input
									type="checkbox"
									className=""
									style={checkboxStyle}
									checked={field.value}
									onChange={(evt) =>
										handleCheck(evt, `${itemName}.seesInvoices`)
									}
								></input>
							)}
						/>
					</Col>
					<Col md="2">
						<label>See Reports</label>
					</Col>
					<Col md="1">
						<Controller
							name={`${itemName}.seesReports`}
							control={control}
							defaultValue={item.seesReports}
							render={(field, fieldState) => (
								<input
									type="checkbox"
									style={checkboxStyle}
									checked={field.value}
									onChange={(evt) =>
										handleCheck(evt, `${itemName}.seesReports`)
									}
								></input>
							)}
						/>
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default UserFormElementsKC;
